if (typeof window === 'undefined') {

    facebookInsightsPostDetails(
        module.exports,
        require('../metric.js'),
        require('../../metrics.js'),
        require('../../collections/metrics.js'),
        require('lodash')
    );

} else {

    facebookInsightsPostDetails(
        RivalIQ.models.metrics,
        RivalIQ.metrics,
        RivalIQ.models,
        RivalIQ.collections,
        window._
    );
}

function facebookInsightsPostDetails(metricModels, metrics, models, collections, _) {

    'use strict';

    const metricBase = metricModels._metricBase;

    metricModels.FacebookInsightsPostDetails = _.extend({}, metricBase, {
        domainFormat: function (value, options) {
            const me = this;
            return me.byOverride('domainFormat', value, options) || me.byDimension('domainFormat', value, options);
        },

        constructDimensionBuckets: function (dimensions, data) {
            _.each(dimensions, function (dimension) {
                _.set(data, ['dimensions', dimension, 'buckets'], {});
            });
        },

        getValue: function (options) {
            const me = this;

            const format = _.get(options, ['format'], true);

            // Some metrics should not be shown if facebook is under reporting.
            if (format && me.get('redactIfUnderReporting') && me.isFacebookUnderReporting()) {
                return '--';
            }

            return metricBase.getValue.apply(me, arguments);
        },

        addDimensionData: function (dimensions, data) {
            const me = this;

            _.each(dimensions, function (dimension) {
                const key = me.attributes[dimension] || me.data[dimension];
                const value = me.getValue({
                    format: false
                });
                const bucketPath = ['dimensions', dimension, 'buckets', key];

                if (key && _.exists(value)) {

                    if (!_.get(data, bucketPath)) {
                        _.set(data, bucketPath, {});
                    }

                    _.set(data, bucketPath.concat(['count']), value);
                }
            });
        },

        create: function (semanticId, attrs) {
            const me = this;

            const propertyAliases = me.get('propertyAliases');
            const properties = _.extend(
                _.pick(me.attributes, 'companyId', 'channel', 'objectType', 'postId'),
                // NOTE UGLY clone to drop prototype
                _.clone(metrics.descriptions[semanticId]),
                attrs
            );

            if (propertyAliases[properties.property]) {
                properties.property = propertyAliases[properties.property];
            }

            const metricData = _.cloneDeep(me.data);
            if (_.isArray(properties.submetrics)) {
                me.constructDimensionBuckets(properties.dimensions, metricData);

                properties.submetrics = _.map(properties.submetrics, function (semanticId) {
                    let submetric;

                    if (_.isString(semanticId)) {
                        submetric = me.create(semanticId);

                    } else {
                        const attrs = _.omit(semanticId, 'semanticId');
                        semanticId = semanticId.semanticId;
                        submetric = me.create(semanticId, attrs);
                    }
                    submetric.addDimensionData(properties.dimensions, metricData);
                    return submetric;
                });
            }

            const definition = new models.MetricDefinition(semanticId, properties);

            _.defaults(definition, _.pick(properties, 'format'));
            definition.data = metricData;
            definition.companyData = me.companyData;

            return definition;
        },

        createAliasValues: function (data) {
            const me = this;

            const propertyAliases = me.get('propertyAliases');

            _.each(propertyAliases, function (alias, property) {
                _.set(data, alias, _.get(data, property));
            });
        },

        fetch: function (attrs) {
            const me = this;
            attrs = _.extend({}, attrs, me.resolvedAttributes(), me.attributes);
            return RivalIQ.apps.Insights.data.facebookInsightsPostDetails
                .fetch(attrs)
                .then(function (data) {
                    const attributes = _.extend({}, me.resolvedAttributes(), me.attributes);

                    me.createAliasValues(data);

                    attributes.submetrics = new collections.Metrics(_.map(attributes.submetrics, function (submetric) {
                        return new models.Metric(submetric.attributes, _.cloneDeep(data));
                    }));

                    const metricData = _.cloneDeep(data);
                    if (attributes.submetrics.size() > 0) {
                        me.constructDimensionBuckets(attributes.dimensions, metricData);
                        attributes.submetrics.each(function (submetric) {
                            submetric.addDimensionData(attributes.dimensions, metricData);
                        });
                    }

                    const metric = new models.Metric(attributes, metricData);
                    metric.companyData = RivalIQ.state.landscape.get('companies');

                    return metric;
                });
        },

        // Remove when facebook fixes their under reporting insights bug.
        isFacebookUnderReporting: function () {
            const me = this;

            // check if the reported engagement on the post is less than the
            // reported engagement on the post and all shares
            const postAndSharesValue = _.get(me.data, ['facebook_insights_data', 'post_stories']);
            const postOnlyValue = _.get(me.data, 'engagement_total');

            // also check if any of the organic engagement values are negative
            const engagementKeys = ['engagement_organic', 'reactions_organic', 'comments_organic', 'shares_organic'];
            const hasNegativeEngagement = _.some(engagementKeys, function (key) {
                return parseInt(_.get(me.data, key)) < 0;
            });

            return (postAndSharesValue < postOnlyValue) || hasNegativeEngagement;
        },

        getIconTag: function () {
            const me = this;

            const imageUrl = _.get(me.attributes, 'iconUrl');

            if (imageUrl) {
                return $.tagHtml('img', {
                    class: 'img-reaction',
                    src: imageUrl
                });
            }
        },

        getClassName: function (data) {
            const me = this;

            if (_.isArray(data)) {
                return data[0];
            }

            return models.Metric.prototype.getClassName.apply(me, arguments);
        }
    });

}
